/*
 * Feel Awsm · Darm Balance Funnel (Gut Balance probiotic)
 * Shopify cart drawer integration + scroll reveal + FAQ + sticky cart + gut-health calculator
 * Class hooks: js-feelawsm-funnel-atc (per spec)
 */
(function(){
  'use strict';

  if (window.__feelawsmKemInitialized) return;
  window.__feelawsmKemInitialized = true;

  document.documentElement.classList.add('kem-js');

  // ============ SCROLL REVEAL ============
  var revealObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){
        e.target.classList.add('kem-in');
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.kem-reveal').forEach(function(el){ revealObserver.observe(el); });

  // ============ FAQ ACCORDION (only one open at a time) ============
  var faqItems = document.querySelectorAll('.kem-faq-item');
  faqItems.forEach(function(item){
    item.addEventListener('toggle', function(){
      if (item.open){
        faqItems.forEach(function(other){
          if (other !== item && other.open){ other.open = false; }
        });
      }
    });
  });

  // ============ STICKY CART SHOW/HIDE ============
  var sticky = document.getElementById('kem-sticky');
  var hero   = document.querySelector('.kem-hero');
  var lastY  = 0, ticking = false;
  window.addEventListener('scroll', function(){
    if (!ticking){
      window.requestAnimationFrame(function(){
        var y = window.scrollY;
        var threshold = hero ? (hero.offsetTop + hero.offsetHeight - 120) : 600;
        if (sticky){
          if (y > threshold) sticky.classList.add('kem-show');
          else sticky.classList.remove('kem-show');
        }
        lastY = y;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // ============ INGREDIENTS "SHOW ALL" TOGGLE ============
  var blocksToggle = document.querySelector('.kem-blocks-toggle button');
  var blocksWrap   = document.querySelector('.kem-blocks');
  if (blocksToggle && blocksWrap){
    blocksToggle.addEventListener('click', function(){
      var open = blocksWrap.classList.toggle('kem-show-all');
      blocksToggle.textContent = open
        ? (blocksToggle.dataset.lessLabel || 'Show fewer ingredients ↑')
        : (blocksToggle.dataset.moreLabel || 'See all 16 ingredients ↓');
    });
  }

  // ============ GUT HEALTH CALCULATOR ============
  var calcBtn = document.querySelector('.kem-calc-btn');
  if (calcBtn){
    calcBtn.addEventListener('click', function(){
      var ageInput = document.getElementById('kem-calc-age');
      var age      = parseInt(ageInput && ageInput.value, 10) || 35;
      var bloat    = (document.querySelector('input[name="kem-bloat"]:checked') || {}).value || 'sometimes';
      var uti      = (document.querySelector('input[name="kem-uti"]:checked')   || {}).value || 'no';
      var abx      = (document.querySelector('input[name="kem-abx"]:checked')   || {}).value || 'no';
      var stressEl = document.getElementById('kem-calc-stress');
      var stress   = (stressEl && stressEl.value) || 'medium';
      var diet     = (document.querySelector('input[name="kem-diet"]:checked')  || {}).value || 'mixed';

      var base = 100 - Math.max(0, (age - 28) * 0.6);
      if (bloat === 'often')      base -= 20;
      else if (bloat === 'sometimes') base -= 10;
      if (uti === 'yes')          base -= 18;
      if (abx === 'yes')          base -= 14;
      if (stress === 'medium')    base -= 6;
      if (stress === 'high')      base -= 14;
      if (diet === 'poor')        base -= 10;
      else if (diet === 'mixed')  base -= 4;
      base = Math.max(18, Math.min(100, Math.round(base)));

      var scoreEl = document.getElementById('kem-result-score');
      var catEl   = document.getElementById('kem-result-cat');
      var msgEl   = document.getElementById('kem-result-msg');
      var boostEl = document.getElementById('kem-boost');
      var fillEl  = document.getElementById('kem-prog-fill');
      var panel   = document.getElementById('kem-result');

      if (scoreEl) scoreEl.textContent = base + '%';
      if (fillEl){
        fillEl.style.width = base + '%';
        if (base >= 80)      fillEl.style.background = 'linear-gradient(90deg,#3F6F44,#7A9E7E)';
        else if (base >= 65) fillEl.style.background = 'linear-gradient(90deg,#A57E26,#E8C06A)';
        else if (base >= 50) fillEl.style.background = 'linear-gradient(90deg,#B8446A,#E890B0)';
        else                 fillEl.style.background = 'linear-gradient(90deg,#903050,#B8446A)';
      }

      /*
       * Result strings — read from #kem-calc-results in the DOM so each
       * category (Balanced / Mild / Noticeable / Significant) is
       * translatable via Shopify Translate & Adapt. Each bucket is one
       * <div> with data-bucket="80|65|50|0" and <strong>cat</strong>
       * <em>msg</em><small>boost</small> inside.
       */
      function readBucket(threshold){
        var el = document.querySelector('#kem-calc-results div[data-bucket="'+threshold+'"]');
        if (!el) return null;
        var t = el.querySelector('strong'), m = el.querySelector('em'), b = el.querySelector('small');
        return { cat: t ? t.textContent : '', msg: m ? m.textContent : '', boost: b ? b.textContent : '' };
      }
      var result = null;
      if      (base >= 80) result = readBucket('80');
      else if (base >= 65) result = readBucket('65');
      else if (base >= 50) result = readBucket('50');
      else                 result = readBucket('0');
      var cat = result ? result.cat : '', msg = result ? result.msg : '', boost = result ? result.boost : '';
      if (catEl)   catEl.textContent   = cat;
      if (msgEl)   msgEl.textContent   = msg;
      if (boostEl) boostEl.textContent = boost;
      if (panel){
        panel.classList.add('kem-show');
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  // ============ CART DRAWER INTEGRATION (Dawn pattern — Electrolyte working version) ============
  // Mirrors Dawn's product-form.js: regular items send `sections` + `sections_url`
  // in the /cart/add.js body so Shopify returns pre-rendered section HTML.
  // Selling-plan items use XHR without `sections` (Shopify quirk — Liquid error
  // if sections are included together with selling_plan on /cart/add.js).
  // State cleanup uses .finally{} so the button always returns to its idle state,
  // even if renderContents() throws during cart drawer update.
  var addingLabel = 'Adding\u2026';

  function getCartUi(){
    return document.querySelector('cart-notification')
        || document.querySelector('cart-drawer');
  }
  function getCartAddUrl(){
    var path = (typeof window.routes !== 'undefined' && window.routes.cart_add_url)
      ? String(window.routes.cart_add_url) : '/cart/add';
    if (path.charAt(0) === '/' && path.indexOf('cart') !== -1){
      return path.replace(/\/cart\/add\/?$/, '/cart/add.js');
    }
    return '/cart/add.js';
  }
  function getCartUrl(){
    return (typeof window.routes !== 'undefined' && window.routes.cart_url)
      ? String(window.routes.cart_url) : '/cart';
  }
  function parseQty(btn){
    var q = parseInt(btn.getAttribute('data-quantity'), 10);
    return (!isNaN(q) && q > 0) ? q : 1;
  }
  // Fallback: if the /cart/add.js response doesn't include sections (e.g. because
  // we couldn't send `sections` in the body — as for selling plans), fetch each
  // section the drawer cares about from the cart URL and stitch them into the
  // shape Dawn's renderContents() expects.
  function fetchSectionHtmlForCart(cart, data, doRender){
    if (data.sections || !cart || typeof cart.getSectionsToRender !== 'function'){
      doRender(data);
      return Promise.resolve();
    }
    var sectionIds = cart.getSectionsToRender().map(function(s){ return s.id; });
    if (!sectionIds.length){ doRender(data); return Promise.resolve(); }
    return Promise.all(sectionIds.map(function(id){
      return fetch(getCartUrl() + '?section_id=' + id, { cache: 'no-store' })
        .then(function(r){ return r.text(); });
    }))
      .then(function(htmls){
        var sections = {};
        sectionIds.forEach(function(id, i){ sections[id] = htmls[i]; });
        doRender(Object.assign({}, data, { sections: sections }));
      })
      .catch(function(){ doRender(data); });
  }

  document.querySelectorAll('.js-feelawsm-funnel-atc').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var cart = getCartUi();
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      var spRaw = btn.getAttribute('data-selling-plan') || '';
      var quantity = parseQty(btn);

      if (!vid || isNaN(vid)){
        alert('Missing variant');
        return;
      }

      var sellingPlanId = null;
      if (String(spRaw).trim() !== ''){
        var spNum = parseInt(spRaw, 10);
        if (!isNaN(spNum)) sellingPlanId = spNum;
      }

      var item = { id: vid, quantity: quantity };
      if (sellingPlanId != null) item.selling_plan = sellingPlanId;

      var body = { items: [item] };
      if (cart){
        if (typeof cart.setActiveElement === 'function'){
          cart.setActiveElement(document.activeElement);
        }
        if (sellingPlanId == null && typeof cart.getSectionsToRender === 'function'){
          body.sections = cart.getSectionsToRender().map(function(section){ return section.id; });
          body.sections_url = window.location.pathname;
        }
      }

      var addUrl = getCartAddUrl();
      var bodyString = JSON.stringify(body);

      var previousHtml = btn.innerHTML;
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode(addingLabel));
      btn.classList.add('eef-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-disabled', 'true');

      var cartAddPromise = sellingPlanId != null
        ? new Promise(function(resolve, reject){
            var xhr = new XMLHttpRequest();
            xhr.open('POST', addUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = function(){
              if (xhr.status < 200 || xhr.status >= 400){
                reject(new Error('Cart add failed: ' + xhr.status));
                return;
              }
              try { resolve(JSON.parse(xhr.responseText)); }
              catch(e){ reject(e); }
            };
            xhr.onerror = function(){ reject(new Error('Cart add network error')); };
            xhr.send(bodyString);
          })
        : fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: bodyString
          }).then(function(response){
            if (!response.ok) throw new Error('Cart add failed: ' + response.status);
            return response.json();
          });

      cartAddPromise
        .then(function(response){
          if (response.status){
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS){
              window.publish(window.PUB_SUB_EVENTS.cartError, {
                source: 'feelawsm-darm-funnel',
                productVariantId: String(vid),
                errors: response.errors || response.description,
                message: response.message
              });
            }
            var desc = (response.description || response.message || 'Could not add to cart').toString();
            alert(desc);
            return;
          }

          if (!cart){
            window.location.href = getCartUrl();
            return;
          }

          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS){
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'feelawsm-darm-funnel',
              productVariantId: String(vid),
              cartData: response
            });
          }
          window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

          var doRender = function(data){ cart.renderContents(data); };

          if (cart.classList && cart.classList.contains('is-empty')){
            cart.classList.remove('is-empty');
          }

          return fetchSectionHtmlForCart(cart, response, doRender);
        })
        .catch(function(err){
          console.warn('[feelawsm-darm-funnel]', err);
          var msg = (err && err.message) || 'Could not add to cart';
          alert(msg);
        })
        .finally(function(){
          btn.innerHTML = previousHtml;
          btn.classList.remove('eef-loading');
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('aria-disabled');
        });
    });
  });

  // ============ SMOOTH ANCHOR SCROLL (offset for sticky bar) ============
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    link.addEventListener('click', function(e){
      var href = this.getAttribute('href');
      if (href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 60;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

})();
